import { connect } from 'react-redux';

import ButtonSend from '../../../components/Editor/ButtonSend';
import { StoreState } from '../../../reducers';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		editor: {
			label: { label, isRenaming },
			combo: { isCombining },
		},
		driveList,
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];

	return {
		resourceId: + resourceId,
		label,
		isDisabled: isRenaming || isCombining,
		driveItem: driveList.driveItems[+resourceId],
	};
};

export default connect(mapStateToProps)(ButtonSend);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonSend/index.tsx